// Send Reset Request
export const SETTLE_TRANSACTION = 'SETTLE_TRANSACTION'

export const settleTransaction = (ids, isSettle) => ({
  type: SETTLE_TRANSACTION,
  ids,
  isSettle
})

